import axios from 'axios';
import {
  buttonFormat,
  dateFormat,
  cardFormat,
  newBooking,
  itineraryFormat,
  humanHandoffFormat,
  cancelFormat,
  changeFormat,
  changeHotelFormat,
  changeFlightFormat
} from './dataFormat';

export const createUserMessage = (message) => {
  return {
    text: message,
    sender: 'USER',
    messageType: 'text',
    ts: new Date()
  };
};
const CancelToken = axios.CancelToken;
export let cancel;
export const getBotResponse = async ({
  rasaServerUrl,
  sender,
  message,
  metadata = {}
}) => {
  try {
    const response = await axios({
      method: 'post',
      url: rasaServerUrl,
      data: {
        sender,
        message,
        metadata
      },
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      })
    });
    return response.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      return false;
    } else {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  }
};

export function debounce(func, wait) {
  let timeout;

  const debounced = function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };

  debounced.cancel = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

export const weatherRequest = async (destination) => {
  try {
    const response = await axios({
      method: 'get',
      url: `https://wttr.in/${destination}?format=j1`
    });
    const { data } = response;
    return data;
  } catch (error) {
    console.log('error occurred', error);
    return [];
  }
};

export const getAdvertisement = async () => {
  try {
    const response = await axios({
      method: 'get',
      url: `https://scout-advertisement-server.azurewebsites.net/advertisement/latest`
    });
    const { data } = response;
    return data;
  } catch (error) {
    console.log('error occurred', error);
    return [];
  }
};

export const messageFormat = (response) => {
  const last = response.length - 1;
  const hasFlight = response.some((item) =>
    item.custom?.attachments?.some((attachment) =>
      attachment.hasOwnProperty('FareClasses')
    )
  );
  const hasHotel = response.some((item) =>
    item.custom?.attachments?.some((attachment) =>
      attachment.hasOwnProperty('Rooms')
    )
  );
  const hasCar = response.some((item) =>
    item.custom?.attachments?.some((attachment) =>
      attachment.hasOwnProperty('CarbonEmissionAmount')
    )
  );

  const hasItinerary = response[1]?.custom?.Itinerary_details != null;
  const isNewBooking =
    response[last]?.custom?.Reason_for_travel_details != null;
  const isDepartment = response[last]?.custom?.Departments != null;
  const hasHuman =
    response[1]?.custom?.chatId !== undefined ||
    response[1]?.custom?.dialogueId !== undefined;
  const isDateText = response.some(({ custom }) =>
    custom?.attachments?.some(({ content }) =>
      content?.body?.some(
        ({ type, id }) => type === 'Input.Date' && id === 'date'
      )
    )
  );
  const cancellationCard = response[last]?.custom?.attachments?.some(
    (attachment) => attachment.hasOwnProperty('complete_cancel_options')
  );
  const isChange = response[last]?.custom?.CHANGE_QUERY_OPTIONS !== undefined;
  const isChangeHotel = response[last]?.custom?.HOTEL_ROOMS !== undefined;
  const isChangeFlight = response[last]?.custom?.FLIGHT_OPTIONS !== undefined;

  switch (true) {
    case hasFlight:
      return cardFormat(response, 'flight');
    case hasHotel:
      return cardFormat(response, 'hotel');
    case hasCar:
      return cardFormat(response, 'car');
    case hasItinerary:
      return itineraryFormat(response, 'Itinerary');
    case isDateText:
      return dateFormat(response);
    case isNewBooking:
      return newBooking(response, 'booking');
    case hasHuman:
      return humanHandoffFormat(response);
    case isDepartment:
      return newBooking(response, 'department'); // department card reused newBooking card
    case cancellationCard:
      return cancelFormat(response, 'cancellation');
    case isChange:
      return changeFormat(response, 'change');
    case isChangeHotel:
      return changeHotelFormat(response, 'changeHotel');
    case isChangeFlight:
      return changeFlightFormat(response, 'changeFlight');
    default:
      return buttonFormat(response);
  }
};
